import { DateTime } from 'luxon';



window.inputDatetime = () => {

  // 要素を取得する
  const elements = document.querySelectorAll('[data-datetime]');

  // ない場合はなにもしない
  if( ! elements ) return;

  // ゼロパディング
  const zeroPaddingSymbol = (str, symbol) => {
    const array = str.split(symbol);
    const zero = array.map( s => s.padStart(2, '0') );
    return zero.join(symbol);
  };

  // 入力した日付を整形する
  const transformDateValue = (arg) => {
    // 現在
    const now = DateTime.now();
    // 今年
    const thisYear = now.year;
    // 西暦の頭の二桁だけ取得
    const twoDigit = String(thisYear).substring(0, 2);

    // 入力された文字列のドットとスラッシュをハイフンに置換する（日付）
    let date = arg.replace(/\.|\//g, '-');
        date = zeroPaddingSymbol(date, '-');

    // 変換されたハイフンの文字数
    const count = (date.match(/-/g) || []).length;

    // ハイフンの文字数が1個の時は月-日の入力と判断する
    if( count === 1 ) {
      date = thisYear + '-' + date;
    }
    // ハイフンの文字数が2個の時は年-月-日の入力と判断する
    else if( count === 2 ) {
      // 年の部分だけ抜き取る（配列が返ってくる）
      let y = date.match(/^[0-9]+/);

      if( y[0].length < 3 ){
        y = y[0].padStart(2, '0');
        y = twoDigit.toString() + y.toString();
      }

      date = date.replace(/^[0-9]+/, y);

    }
    // それ以外はエラー
    else {
      return false;
    }

    // バリデーションする
    const checkDate = DateTime.fromSQL(date);
    if( checkDate.isValid === false ) return false;

    return date;

  };



  // イベントセット
  for(let elm of elements){
    elm.addEventListener('focusout', function(e){

      const value = e.target.value;

      // value ない場合はなにもしない
      if( ! value ) return;

      // 現在
      const now = DateTime.now();

      // 入力された文字列を空白で配列に変換する（日付と時間を分ける）
      const splitting = value.split(/\s+/);

      // 配列が2つを超える場合はエラー
      if( splitting.length > 2 ) return 'error';

      // 日付を整形する
      const date = transformDateValue(splitting[0]);

      // 日付が不正なものは何もしない
      if( ! date ) return false;

      // 時間
      let time = false;
      if( splitting[1] ){
        time = splitting[1].replace(/\.|\/|-/g, ':');
        time = zeroPaddingSymbol(time, ':');
      } else {
        // 現在の時刻
        time = zeroPaddingSymbol( now.toLocaleString(DateTime.TIME_24_WITH_SECONDS), ':');
      };

      // format を取得
      let format = e.target.dataset.datetime;
      if( ! format ) format = 'yyyy-MM-dd';

      // 最終的な日付
      const dateValue = date + ' ' + time;
      e.target.value = DateTime.fromSQL(dateValue).toFormat(format);

      // change イベントを発火
      const changeEvent = new Event( 'change', { 'bubbles': true, 'cancelable': true });
      e.target.dispatchEvent(changeEvent);

    });
  };

  return;

};
